import {IntegrationTypeNum} from 'enums/integrations';

export const getIsGoogleClassRoom = (type: number) => type === IntegrationTypeNum.GOOGLE_CLASSROOM;
